import { Link } from 'react-router-dom'
import { getCurrentYear } from '@/utils/date-format-util'

const Footer = () => {
  const LINK_ACCOUNT_MORE = 'account/more'

  return (
    <div
      id="app-footer"
      className="flex flex-col w-full bg-neutral-900 py-12 px-[5%] lg:px-[10%] max-md:px-8 text-white gap-8 max-md:gap-10 md:h-[176px]"
    >
      <p className="font-inter text-base font-normal leading-6 text-left">
        The Fasten Rewards™ Visa Card is issued by Celtic Bank, pursuant to a license by Visa U.S.A., Inc. All cards
        are subject to credit approval.
      </p>
      <div className="flex justify-between max-md:flex-col max-md:gap-10">
        <div className="flex gap-8">
          <Link to={LINK_ACCOUNT_MORE}>
            <button
              id="help-button"
              aria-label="Help"
              className="font-sans text-base font-semibold leading-6 text-left text-white whitespace-nowrap"
            >
              Help
            </button>
          </Link>
          <Link to={LINK_ACCOUNT_MORE}>
            <button
              id="legal-button"
              aria-label="Legal"
              className="font-inter text-base font-semibold leading-6 text-left text-white whitespace-nowrap"
            >
              Legal
            </button>
          </Link>
        </div>
        <div className="font-inter text-base font-normal leading-6 md:text-right text-white whitespace-nowrap">
          © {getCurrentYear()} Fasten Rewards Inc.
        </div>
      </div>
    </div>
  )
}

Footer.propTypes = {}

export default Footer